import React, {  useState, useEffect } from "react";
import { Button , Row, Col, CardBody, Card} from 'reactstrap';
import axios from 'axios';
import { ProductAwardHubspot } from "views/Hoc/Dialog/HubSpotFormDialog";
// import ReactPlayer from "react";


const EventAwards = (props) => {

    const [loading, setLoading] = useState(false);
    const [isHubspot, setIsHubspot] = useState(false);
    const [hubSpotIds, setHubSpotIds] = useState([]);
    let [hubSpotFormData, setHubSpotFormData] = useState(null);
    const [openHubsportAwartDialog, setOpenHubsportAwartDialog] = useState(false);
    useEffect(() => {
      let eventId = props.eventId;
     getHubSpot(eventId);
    }, []);
  //  console.log('errprs', errors)

    const getHubSpot = async(eventId) => {
      await axios.get('channel/getEventHubspotForms/' + eventId)
            .then(res => {
             
                  if(res.data.externalIds){
                   
                    setIsHubspot(true);
                   
                    //setHubSpotIds([])
                     setHubSpotIds(res.data.externalIds)
                  }
            }).catch(err => console.log("getsubject:", err));
    }

    const openHubSpotDialog = (data) => {
      setHubSpotFormData(data)
      setOpenHubsportAwartDialog(true)
    }
    const closeAwardDialog = () => {
      //  setHubSpotFormData(data)
      setOpenHubsportAwartDialog(false)
    }

    return (
    <>
          {openHubsportAwartDialog && <ProductAwardHubspot closeUserView={closeAwardDialog} value={hubSpotFormData}/>}
      <>
          <div>

            <Card id='Favourites' className="main-content">
                <CardBody>
                  <Row className="justify-content-center" style={{padding:"34px"}}>
                  Click on the below button to open the form
                  
                  </Row>
                  
                        {     
                          hubSpotIds.map(x => (
                            <Row className="justify-content-center">
                              <p className="pointer">          
                                <Button  className="btn-sin btn btn-primary" onClick={() => openHubSpotDialog(x.id)}>{x.title}</Button>
                              </p>
                            </Row>  
                          ))
                        }
                  
                </CardBody>
              </Card>
           
          </div>
      </>
    
    </>
    )
};

export default EventAwards;